import { FaultCode, ViError } from '@vi-iot/client/index';
import { ServiceTicketCallType, ServiceTicketRoutingProvider } from './service-ticket.model';

export namespace ServiceTicketHelper {
  export const faultCodeTextMapper = (faultCode: FaultCode): string => {
    return `(${faultCode.faultCode}) ${faultCode.systemCharacteristics.replace(/<[^>]*>/g, '')}`;
  };

  export const getCallType = (
    routingProvider: ServiceTicketRoutingProvider,
    error?: ViError
  ): ServiceTicketCallType => {
    if (error) {
      return ServiceTicketCallType.ArrangedCallback;
    }

    if (routingProvider === ServiceTicketRoutingProvider.Salesforce) {
      return ServiceTicketCallType.CallNow;
    }

    if (routingProvider === ServiceTicketRoutingProvider.Vonage) {
      return ServiceTicketCallType.ArrangedCallback;
    }

    return ServiceTicketCallType.CallNow;
  };
}
